var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNocoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#EAEFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1657 18.8471L45.1656 18.847C44.9094 18.5878 44.6042 18.3822 44.2678 18.2422C43.9313 18.1021 43.5704 18.0304 43.206 18.0313L43.2059 18.0313L35.5229 18.0313C35.0271 18.0322 34.5517 18.2286 34.1998 18.5778L18.8406 33.934C18.3223 34.4533 18.0312 35.157 18.0312 35.8906C18.0312 36.6243 18.3223 37.328 18.8405 37.8473L45.1657 18.8471ZM45.1657 18.8471C45.4224 19.1031 45.6256 19.4076 45.7635 19.7428C45.9014 20.078 45.9713 20.4373 45.9691 20.7998V20.8V28.4874C45.9677 28.9833 45.7706 29.4585 45.4207 29.8098L30.0676 45.1598C29.5482 45.6782 28.8442 45.9694 28.1103 45.9694C27.3764 45.9694 26.6725 45.6782 26.153 45.1598L18.8406 37.8473L45.1657 18.8471ZM38.8718 25.6889C39.2058 25.9121 39.5986 26.0313 40.0003 26.0313C40.539 26.0313 41.0557 25.8173 41.4366 25.4363C41.8176 25.0554 42.0316 24.5387 42.0316 24C42.0316 23.5983 41.9124 23.2055 41.6892 22.8715C41.466 22.5375 41.1488 22.2771 40.7776 22.1234C40.4065 21.9696 39.9981 21.9294 39.604 22.0078C39.21 22.0862 38.8481 22.2796 38.564 22.5637C38.2799 22.8478 38.0865 23.2097 38.0081 23.6037C37.9297 23.9978 37.9699 24.4062 38.1237 24.7773C38.2774 25.1485 38.5378 25.4657 38.8718 25.6889Z",
    fill: "#2D5D2A",
    stroke: "#2D5D2A",
    strokeWidth: 0.0625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNocoupons);
export default __webpack_public_path__ + "static/media/ic_nocoupons.e68f593860cf3c1df69637b7e8692ba2.svg";
export { ForwardRef as ReactComponent };